export const locales = ['en', 'sr', 'hu'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  sr: 'Srpski',
  hu: 'Magyar',
};
